import { render, staticRenderFns } from "./LuggageItem.vue?vue&type=template&id=b55d44ca&scoped=true&"
import script from "./LuggageItem.vue?vue&type=script&lang=js&"
export * from "./LuggageItem.vue?vue&type=script&lang=js&"
import style0 from "./LuggageItem.vue?vue&type=style&index=0&id=b55d44ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55d44ca",
  null
  
)

export default component.exports